export default __webpack_public_path__ + "static/media/earrings_light.85f3c68b.png";